var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteractiveInprogressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_906",
    "data-name": "Rectangle 906",
    width: 10,
    height: 9,
    rx: 1,
    transform: "translate(4 9)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interactive_inprogress_icon",
    transform: "translate(-306 -1151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_977",
    "data-name": "Rectangle 977",
    width: 26,
    height: 26,
    transform: "translate(306 1151)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1839",
    "data-name": "Group 1839",
    transform: "translate(306 1151)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(1 1)",
    fill: "#afb4c5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1838",
    "data-name": "Group 1838",
    transform: "translate(1 0.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1837",
    "data-name": "Group 1837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M12751-11968.5h-10a.5.5,0,0,1-.5-.5v-13a.5.5,0,0,1,.5-.5h9.034l1.467,2.222V-11969A.5.5,0,0,1,12751-11968.5Z",
    transform: "translate(-12733 11988)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M-12722.947,11988.58l-.869,2.445,2.212-.162Z",
    transform: "translate(12313.836 -12419.775) rotate(-2)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1836",
    "data-name": "Group 1836"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    x2: 3,
    transform: "translate(14.5 9.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    x2: 3,
    transform: "translate(14.5 11.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    x2: 3,
    transform: "translate(14.5 13.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    x2: 3,
    transform: "translate(14.5 15.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-volume-2",
    "data-name": "Icon feather-volume-2",
    transform: "translate(11.656 9.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M4.209,7.5l-.672.537H3v.806h.537l.672.537Z",
    transform: "translate(0 -0.096)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M23.784,7.395a1.343,1.343,0,0,1,0,1.9M23.31,7.869a.672.672,0,0,1,0,.95",
    transform: "translate(-18.491 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1835",
    "data-name": "Group 1835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_905",
    "data-name": "Rectangle 905",
    transform: "translate(4 8)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 9,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 9.5,
    height: 8.5,
    rx: 0.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    transform: "translate(6 10)",
    fill: "#afb4c5",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.85,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_38",
    "data-name": "Mask Group 38",
    transform: "translate(0 -1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M-12735.016,11996.949a4.487,4.487,0,0,1,2.411-1.088c1.178,0,1.51.977,2.928,1.37a7.5,7.5,0,0,0,2.745.2l1.368-.2v2.312h-9.452Z",
    transform: "translate(12739.289 -11981.889)",
    fill: "#afb4c5",
    stroke: "#fff",
    strokeWidth: 0.4
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractiveInprogressIcon);
export default __webpack_public_path__ + "static/media/interactive_inprogress_icon.fcf67e2479b357b426caf33efd087648.svg";
export { ForwardRef as ReactComponent };